import subContext from './sub-context.js'
import Vue from 'vue'

/**
 * Builds a sub list.
 *
 * @param context
 * @return {{mutations: {}, state: {}, getters: {}, actions: {}, namespaced: boolean}}
 */
function buildSubList (context) {
  const {resource, $name, $namespace, $parentNamespace} = context
  const RESET = 'LOOKUP_LIST_RESET'
  const SET_OPTIONS = 'LOOKUP_LIST_SET_OPTIONS'
  const SET_ERROR = 'LOOKUP_LIST_SET_ERROR'
  const UPDATE_SEARCH = 'UPDATE_SEARCH'
  const SET_SELECTED = 'SET_SELECTED'
  const SET_SELECTED_ITEM = 'SET_SELECTED_ITEM'

  if (!resource.operations.list) {
    console.log(resource)
    throw new Error('Logic exception? Resource has no list URL: ' + resource.name)
  }
  const companyParameter = resource.operations.list.parameters.reduce((previous, parameter) => {
    return (parameter.name.substring(0, 7) === 'company') ? parameter.name : previous
  }, null)

  const rootName = RegExp($namespace.split('/')[0] + '[s]?\\[exists\\]');
  const parentExistsParameter = resource.operations.list.parameters.reduce((previous, parameter) => {
    return (rootName.test(parameter.name)) ? parameter.name : previous
  }, null)
  console.log(resource.name, parentExistsParameter, rootName, resource.operations.list.parameters)

  return {
    namespaced: true,
    state: {
      $name,
      $namespace,
      $parentNamespace,
      error: '',
      options: [],
      search: '',
      selected: null,
      selectedItem: null
    },
    actions: {
      load: ({ commit, dispatch, state, rootGetters}) => {
        const params = [
          'itemsPerPage=10'
        ]
        if (state.search) {
          params.push('&orSearch_contains=' + state.search)
        }
        if (companyParameter) {
          params.push(companyParameter + '=' + rootGetters['authentication/selectedCompanyId'])
        }
        if (parentExistsParameter) {
          params.push(parentExistsParameter + '=true')
        }
        const uri = resource.operations.list.url + '?' + params.join('&')
        dispatch('api/fetch', {uri}, { root: true })
          .then(response => response.json())
          .then((data) => {
            commit(SET_OPTIONS, data['hydra:member'])
          })
          .catch((e) => {
            commit(SET_ERROR, e.message)
          })
      },
      reset: ({commit}) => {
        commit(RESET)
      },
      search: ({ commit, dispatch }, search) => {
        commit(UPDATE_SEARCH, search)
        dispatch('load')
      },
      select: ({ commit, dispatch, state }, iri) => {
        commit(SET_SELECTED, iri)
        dispatch(state.$parentNamespace + '/select', {[state.$name]: iri}, {root: true})

        if (!iri) {
          commit(SET_SELECTED_ITEM, null)
          return
        }
        if (!state.options.some((item) => {
          if (item['@id'] === iri) {
            commit(SET_SELECTED_ITEM, item)
            return true
          }
          return false
        })) {
          const uri = resource.operations.list.url + '?uuid=' + iri.split('/').pop()
          dispatch('api/fetch', {uri}, { root: true })
            .then(response => response.json())
            .then((data) => {
              const options = data['hydra:member']
              commit(SET_SELECTED_ITEM, options[0])
            })
            .catch((e) => {
              commit(SET_ERROR, e.message)
            })
        }
      }
    },
    getters: {
      error: state => state.error,
      options: state => state.options,
      search: state => state.search,
      selected: state => state.selected,
      selectedItem: state => state.selectedItem,
    },
    mutations: {
      [RESET] (state) {
        Object.assign(state, {
          error: '',
          options: [],
          search: ''
        })
      },
      [SET_ERROR] (state, error) {
        Object.assign(state, { error })
      },
      [SET_OPTIONS] (state, options) {
        Object.assign(state, { options })
      },
      [UPDATE_SEARCH] (state, search) {
        state.search = search
      },
      [SET_SELECTED] (state, selected) {
        state.selected = selected
      },
      [SET_SELECTED_ITEM] (state, selectedItem) {
        Vue.set(state, 'selectedItem', selectedItem)
      }
    }
  }
}

/**
 * Build a lookup store for filtering for linked object references (used in list stores).
 *
 * @param {ModuleBuilderContext} context
 * @param {object} properties
 *
 * @return object
 */
export default function buildLookupList (context, properties) {
  const {$name, $namespace, $parentNamespace} = context;
  const references = {}
  const referenceNames = []
  Object.keys(properties).map((propName) => {
    const reference = properties[propName].reference
    if (reference) {
      const resource = context.parsed[reference]
      if (resource && resource.operations.list && resource.operations.list.parameters.some((parameter) => parameter.name === 'orSearch_contains')) {
        references[propName] = buildSubList(subContext(context, propName, {resource, parentResource: context.resource}))
        referenceNames.push(propName)
      }
    }
  });
  if (referenceNames.length === 0) {
    return undefined
  }

  return {
    namespaced: true,
    state: {
      $name,
      $namespace,
      $parentNamespace
    },
    modules: {
      ...references
    },
    actions: {
      select: ({dispatch, state}, select) => {
        dispatch(state.$parentNamespace + '/setFilter', select, {root: true})
      },
      reset: ({ dispatch }) => {
        referenceNames.map((propName) => {
          dispatch(propName + '/reset')
        })
      }
    }
  }
}
